import React from 'react';
import styles from './HelpCenter.module.css';
import classNames from 'classnames';
import { useWhitelabelConfig } from '@mm/hooks';

export const HelpCenter = ({
  helpLink,
  className,
  icon,
  title = 'Help Center',
}: {
  helpLink: string;
  className?: string;
  icon?: React.ReactNode;
  title?: string;
}) => {
  const { isWhitelabelCompany } = useWhitelabelConfig();
  if (isWhitelabelCompany) {
    return <></>;
  }
  return (
    <div
      className={classNames(styles.help, className)}
      onClick={() => window.open(helpLink, '_blank')}
    >
      {icon}
      {title}
    </div>
  );
};
